// extracted by mini-css-extract-plugin
export default {"agreementArea":"TermsPage_agreementArea__SMRQ1"};